import { box, ln, mark, on, we, wp, type HandPart } from "./hand-icon";
import { LineIcon } from "./PlanIcon";

/*
  料金の表の行の名前、返金、ローンの利点と手順に添えるアイコン。描き方は hand-icon.tsx の「B 手の揺れの太線」。
  人は顔が黄、円は黄の硬貨、時計は黄の文字盤、角帽は卒業後、包みは特典、盾は返金、
  % は低金利、スマホは来店なしの申し込み、財布は月々の負担、虫眼鏡は診断、銀行は銀行の選択、チェックの板は受講の手続き
*/
const GIFT: HandPart[] = [
  box(4.2, 12.6, 15.6, 8.4, 2),
  mark(box(2.6, 8.2, 18.8, 4.4, 1.4)),
  "M12 12.8v8",
  "M12 8C11.1 5.2 8.8 3.5 7.3 4.2c-1.5.7-1 3.3 4.7 3.8zM12 8c.9-2.8 3.2-4.5 4.7-3.8 1.5.7 1 3.3-4.7 3.8z",
];

export const PRICING_ICON_PATHS = {
  user: [mark(we(12, 7.6, 4)), "M4.2 21c.5-4.2 3.5-6.6 7.8-6.6s7.3 2.4 7.8 6.6"],
  yen: [mark(we(12, 12, 9.2)), on("M8.6 6.6 12 11l3.4-4.4M12 11v6.6M8.8 12.4h6.4M8.8 15.2h6.4", 2)],
  clock: [mark(we(12, 12, 9.2)), on("M12 6.8v5.4l3.4 2", 2.4)],
  graduate: [
    "M6.5 10.6v3.7c1.4 1.5 3.3 2.3 5.5 2.3s4.1-.8 5.5-2.3v-3.7",
    mark(
      wp(
        [
          [12, 3.2],
          [22, 8.1],
          [12, 13],
          [2, 8.1],
        ],
        { r: 1.2 },
      ),
    ),
    "M20.3 9.1v4.7",
    "M3.8 18.9c2.3 2.1 5.1 3.1 8.3 3.1 3.1 0 5.9-1 8.1-3.1",
  ],
  gift: GIFT,
  shield: [
    mark("M12 2.6c2.4 1.6 5 2.6 7.8 2.8v6.6c0 4.8-3.2 8-7.8 9.6-4.6-1.6-7.8-4.8-7.8-9.6V5.4c2.8-.2 5.4-1.2 7.8-2.8z"),
    on(
      wp(
        [
          [8.4, 12.2],
          [11, 14.7],
          [15.8, 9.6],
        ],
        { closed: false, r: 0.8, w: 0.4 },
      ),
      2.4,
    ),
  ],
  percent: [ln(18.6, 5.4, 5.4, 18.6), mark(we(7, 7, 2.8)), we(17, 17, 2.8)],
  phone: [mark(box(6, 2.5, 12, 19, 2.6)), on(ln(10.4, 18, 13.6, 18), 2.4)],
  wallet: [
    "M5.4 6V4.9c0-1 .9-1.7 1.9-1.5l9.6 2.2",
    mark(box(2.6, 6.2, 18.8, 14.6, 2.5)),
    on("M16.6 13.5h.01", 3),
  ],
  search: [mark(we(10.4, 10.4, 7)), ln(16, 16, 21, 21)],
  bank: [
    mark(
      wp(
        [
          [12, 2.6],
          [21, 7.6],
          [3, 7.6],
        ],
        { r: 1 },
      ),
    ),
    "M6.5 11.3v5.8M10.2 11.3v5.8M13.8 11.3v5.8M17.5 11.3v5.8",
    ln(3, 21, 21, 21),
  ],
  rise: [
    wp(
      [
        [2.6, 17.6],
        [8.6, 11.4],
        [13.4, 16],
        [21, 7.8],
      ],
      { closed: false, r: 1 },
    ),
    wp(
      [
        [15.4, 6.8],
        [21.4, 6.8],
        [21.4, 12.8],
      ],
      { closed: false, r: 1 },
    ),
  ],
  briefcase: [
    "M9 6.4V5a1.6 1.6 0 0 1 1.6-1.6h2.8A1.6 1.6 0 0 1 15 5v1.4",
    mark(box(2.6, 6.6, 18.8, 14, 2.5)),
    on("M3 12.6h18M12 11.2v2.8", 2.2),
  ],
  // 在宅は、黄の家と扉
  home: [
    mark(
      wp([
        [3, 10.4, 1],
        [12, 3, 1],
        [21, 10.4, 1],
        [21, 21],
        [3, 21],
      ]),
    ),
    on(
      wp(
        [
          [9.6, 20.6],
          [9.6, 14.6],
          [14.4, 14.6],
          [14.4, 20.6],
        ],
        { closed: false, r: 1 },
      ),
      2.4,
    ),
  ],
  check: [
    wp(
      [
        [4, 12.6],
        [9.2, 17.6],
        [20, 6.4],
      ],
      { closed: false, r: 1 },
    ),
  ],
  x: [ln(6, 6, 18, 18), ln(18, 6, 6, 18)],
  clipboard: [
    wp(
      [
        [16.2, 4.4],
        [19.6, 4.4],
        [19.6, 21.2],
        [4.4, 21.2],
        [4.4, 4.4],
        [7.8, 4.4],
      ],
      { closed: false, r: 2.2 },
    ),
    mark(box(8.4, 2.2, 7.2, 4.6, 1.2)),
    wp(
      [
        [8.4, 13.8],
        [11, 16.2],
        [15.6, 11.2],
      ],
      { closed: false, r: 0.8, w: 0.4 },
    ),
  ],
} satisfies Record<string, HandPart[]>;

export type PricingIconName = keyof typeof PRICING_ICON_PATHS;

export function PricingIcon({ name, className = "pp-ic", size = 20 }: { name: PricingIconName; className?: string; size?: number }) {
  return <LineIcon paths={PRICING_ICON_PATHS[name]} className={className} size={size} />;
}
